module.exports = __webpack_public_path__ + "static/media/logo-comune-bronte.083b8509.png";